import { BUTTON, Button } from 'components/common/Button/Button';

const DownloadDataSource = ({onDownloadDataSource}) => {
    return (
        <div data-cy="DownloadDataSource">
            <Button
                bgcolor={BUTTON.BGCOLOR.WHITE}
                type={BUTTON.SIZE.PRIMARY}
                color={BUTTON.COLOR.GREYAlt}
                onClick={onDownloadDataSource}
                text={'Download All Values'}
                data-cy="DownloadDataSource-Download"
                style={{ 
                    outline: '1px solid #A8A8A8',
                    outlineOffset: '-1px' // Negative value moves outline inward
                }}
            />
        </div>
    );
};

export default DownloadDataSource;